import { ApplicationConfigurationRequiredDocumentType, IncomeType } from '@zg-rentals/ts-capps-client';

export const INCOME_DOC_ENCOURAGEMENT_TEXT = {
  [IncomeType.EMPLOYMENT]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including pay stubs, bank statements, and W-2s.',
  [IncomeType.OTHER]:
    'To improve your chances of being offered this rental, provide documents that show your income, such as tax returns or statements/letters from government agencies or financial institutions.',
  [IncomeType.CONTRACTOR_SELF_EMPLOYED]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including 1099, bank statements, tax returns, or any other document that shows your income.',
  [IncomeType.HOUSING_VOUCHER]:
    'To improve your chances of being offered this rental, provide an approval letter from a Housing Authority, housing voucher, or any other document that shows the maximum amount of your housing assistance payment.',
};

export const DOCUMENTS_EXPIRED_TEXT =
  'Some or all of the income documents you previously added have expired. Add the latest documents that support this income.';

export const UNNAMED_INCOME_SOURCE = 'Income source';

// Listed by hand, not from the generated _values: the same enum will also carry pet document types.
// The array order is the display order
export const INCOME_LEVEL_DOCUMENT_TYPES: Record<
  IncomeType,
  ReadonlyArray<ApplicationConfigurationRequiredDocumentType>
> = {
  [IncomeType.EMPLOYMENT]: [
    ApplicationConfigurationRequiredDocumentType.PAY_STUBS,
    ApplicationConfigurationRequiredDocumentType.W2,
    ApplicationConfigurationRequiredDocumentType.EMPLOYMENT_VERIFICATION_LETTER,
  ],
  [IncomeType.CONTRACTOR_SELF_EMPLOYED]: [ApplicationConfigurationRequiredDocumentType.FORM_1099],
  [IncomeType.HOUSING_VOUCHER]: [],
  [IncomeType.OTHER]: [],
};

export const APPLICATION_LEVEL_DOCUMENT_TYPES: ReadonlyArray<ApplicationConfigurationRequiredDocumentType> = [
  ApplicationConfigurationRequiredDocumentType.BANK_STATEMENTS,
  ApplicationConfigurationRequiredDocumentType.TAX_RETURNS,
  ApplicationConfigurationRequiredDocumentType.STATEMENT_OF_ASSETS,
  ApplicationConfigurationRequiredDocumentType.CPA_ATTESTATION,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_OTHER_INCOME,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT,
];

export const GUARANTOR_EXCLUDED_DOCUMENT_TYPES: ReadonlyArray<ApplicationConfigurationRequiredDocumentType> = [
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT,
];

export const INCOME_DOCUMENT_TYPE_ORDER: ReadonlyArray<ApplicationConfigurationRequiredDocumentType> = [
  ...Object.values(INCOME_LEVEL_DOCUMENT_TYPES).flat(),
  ...APPLICATION_LEVEL_DOCUMENT_TYPES,
];

export function isIncomeDocumentType(type: string): type is ApplicationConfigurationRequiredDocumentType {
  return INCOME_DOCUMENT_TYPE_ORDER.some((documentType) => documentType === type);
}
